import * as React from "react";
import { HistoryCard } from "../../HistoryCard";

// shrink-0: in the scrolling column a card must keep its height and let the column scroll, not be squashed.
export const Section: React.FC<{ title: string }> = ({ title, children }) => (
  <div className="shrink-0">
    <HistoryCard title={title}>
      <div className="grid grid-cols-2 gap-3 p-3">{children}</div>
    </HistoryCard>
  </div>
);
